import { useState } from "react";
import { t } from "ttag";
import 'dayjs/locale/mn';

import type { DateValue, DatesRangeValue } from "metabase/ui";
import { DatePicker, Group, Stack, Text, TimeInput } from "metabase/ui";

import { setDatePart, setTimePart } from "../../utils";

import S from "./DateRangePickerBody.module.css";

interface DateRangePickerBodyProps {
  value: [Date, Date];
  hasTime: boolean;
  onChange: (value: [Date, Date]) => void;
}

export function DateRangePickerBody({
  value,
  hasTime,
  onChange,
}: DateRangePickerBodyProps) {
  const [startDate, endDate] = value;
  const [inProgressDateRange, setInProgressDateRange] =
    useState<DatesRangeValue | null>(value);

  const handleRangeChange = (newDateRange: DatesRangeValue) => {
    const [newStartDate, newEndDate] = newDateRange;
    if (newStartDate && newEndDate) {
      onChange([
        setDatePart(startDate, newStartDate),
        setDatePart(endDate, newEndDate),
      ]);
      setInProgressDateRange(null);
    } else {
      setInProgressDateRange(newDateRange);
    }
  };

  const handleStartTimeChange = (newTime: Date | null) => {
    newTime && onChange([setTimePart(startDate, newTime), endDate]);
  };
  const handleEndTimeChange = (newTime: Date | null) => {
    newTime && onChange([startDate, setTimePart(endDate, newTime)]);
  };

  return (
    <Stack className={S.Root}>
      <Group align="center">
        <Text c="text-normal">
          {startDate.toLocaleDateString("mn-MN")}
        </Text>
        <Text c="text-light">{t`болон`}</Text>
        <Text c="text-normal">
          {endDate.toLocaleDateString("mn-MN")}
        </Text>
      </Group>

      {hasTime && (
        <Group align="center">
          <TimeInput
            className={S.FlexTimeInput}
            value={startDate}
            aria-label={t`Эхлэх цаг`}
            onChange={handleStartTimeChange}
          />
          <Text c="text-light">{t`болон`}</Text>
          <TimeInput
            className={S.FlexTimeInput}
            value={endDate}
            aria-label={t`Дуусах цаг`}
            onChange={handleEndTimeChange}
          />
        </Group>
      )}

      <DatePicker
        type="range"
        value={inProgressDateRange ?? value}
        defaultDate={startDate}
        numberOfColumns={2}
        allowSingleDateInRange
        locale="mn"
        hideOutsideDates
        onChange={handleRangeChange}
      />
    </Stack>
  );
}
